// Redux imports
import { User } from "@finway-group/shared/lib/models"
import { Action } from "redux"
import { WeavrAuthenticatedEnum, WeavrUserOnboardEnum } from "Shared/store/reducers/authReducer"

// Model imports

export enum AuthActionTypes {
    LOGIN = "LOGIN",
    LOGOUT = "LOGOUT",
    LOGGED_OUT = "LOGGED_OUT",
    TOKEN_REFRESH = "TOKEN_REFRESH",
    TOKEN_REFRESHED = "TOKEN_REFRESHED",
    RESET = "RESET",
    SET_TOKENS = "SET_TOKENS",
    SET_WEAVR_AUTH = "SET_WEAVR_AUTH",
    SET_WEAVR_USER_ONBOARD = "SET_WEAVR_USER_ONBOARD",
    SET_AUTH_USER = "SET_AUTH_USER",
}

export interface LoginAction extends Action<typeof AuthActionTypes.LOGIN> {
    type: typeof AuthActionTypes.LOGIN
    user: User
}

export interface SetAuthUserAction extends Action<typeof AuthActionTypes.SET_AUTH_USER> {
    type: typeof AuthActionTypes.SET_AUTH_USER
    user: User
}

export interface LogoutAction extends Action<typeof AuthActionTypes.LOGOUT> {
    type: typeof AuthActionTypes.LOGOUT
}

export interface LoggedoutAction extends Action<typeof AuthActionTypes.LOGGED_OUT> {
    type: typeof AuthActionTypes.LOGGED_OUT
}

export interface TokenRefreshAction extends Action<typeof AuthActionTypes.TOKEN_REFRESH> {
    type: typeof AuthActionTypes.TOKEN_REFRESH
}

export interface TokenRefreshedAction extends Action<typeof AuthActionTypes.TOKEN_REFRESHED> {
    type: typeof AuthActionTypes.TOKEN_REFRESHED
}

export interface SetTokensAction extends Action<AuthActionTypes.SET_TOKENS> {
    type: typeof AuthActionTypes.SET_TOKENS
    accessToken: string
}

export interface ResetAction extends Action<typeof AuthActionTypes.RESET> {
    type: typeof AuthActionTypes.RESET
}

export interface SetIsWeavrAuthenticatedAction extends Action<typeof AuthActionTypes.SET_WEAVR_AUTH> {
    type: typeof AuthActionTypes.SET_WEAVR_AUTH
    isWeavrAuthenticated: WeavrAuthenticatedEnum
}

export interface SetIsWeavrOnboardAction extends Action<typeof AuthActionTypes.SET_WEAVR_USER_ONBOARD> {
    type: typeof AuthActionTypes.SET_WEAVR_USER_ONBOARD
    isWeavrUserOnboard: WeavrUserOnboardEnum
}

export type AuthActions =
    | LoginAction
    | LogoutAction
    | LoggedoutAction
    | TokenRefreshAction
    | TokenRefreshedAction
    | SetTokensAction
    | ResetAction
    | SetIsWeavrAuthenticatedAction
    | SetIsWeavrOnboardAction
    | SetAuthUserAction
